import React from 'react';

/** Virtual per-group status rows — not persisted as AccountGroup subgroups. */
export const GROUP_STATUS_SIDEBAR_FILTERS = [
  { status: 'active', label: 'logged-in' },
  { status: 'suspended', label: 'suspended' },
  { status: 'captcha', label: 'captcha' }
];

/** Model-parent tree: the usual three, plus auth (auth_expired + session extract failed). */
export const MODEL_PARENT_STATUS_FILTERS = [
  { status: 'active', label: 'logged-in' },
  { status: 'suspended', label: 'suspended' },
  { status: 'captcha', label: 'captcha' },
  { status: 'auth_expired', label: 'auth', countKey: 'auth', title: 'Auth expired' }
];

export const EMPTY_GROUP_STATUS_COUNTS = { active: 0, suspended: 0, captcha: 0 };

export function sumLeafStatusCounts(leafSet, leafGroupStatusCounts) {
  const src = leafGroupStatusCounts && typeof leafGroupStatusCounts === 'object'
    ? leafGroupStatusCounts
    : {};
  const out = { ...EMPTY_GROUP_STATUS_COUNTS };
  if (!leafSet) return out;
  for (const leaf of leafSet) {
    const row = src[leaf];
    if (!row) continue;
    out.active += row.active || 0;
    out.suspended += row.suspended || 0;
    out.captcha += row.captcha || 0;
  }
  return out;
}

export default function GroupStatusSidebarFilters({
  selectedGroup,
  groupKey,
  filterStatus,
  counts,
  onSelect,
  filters = GROUP_STATUS_SIDEBAR_FILTERS,
  isActive
}) {
  return (
    <div className="ml-3 mt-0.5 mb-1 space-y-0.5 border-l border-gray-200 dark:border-gray-700 pl-2">
      {filters.map((item) => {
        const { status, label } = item;
        const n = (counts && counts[item.countKey || status]) || 0;
        const active = typeof isActive === 'function'
          ? isActive(status)
          : selectedGroup === groupKey && filterStatus === status;
        return (
          <button
            key={status}
            type="button"
            title={item.title || label}
            onClick={() => onSelect(groupKey, status)}
            className={`w-full text-left px-2 py-1 text-[11px] rounded-md transition-colors flex items-center justify-between ${
              active
                ? 'bg-primary-100 dark:bg-primary-900/30 text-primary-700 dark:text-primary-300 font-medium'
                : 'text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700'
            }`}
          >
            <span>{label}</span>
            <span className="tabular-nums text-gray-400 dark:text-gray-500">({n})</span>
          </button>
        );
      })}
    </div>
  );
}
